import React from 'react';

const ReturnPolicy = () => {
  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-4xl mx-auto px-6 md:px-12 py-20">
        <h1
          className="font-serif text-4xl md:text-5xl text-charcoal mb-4"
          data-testid="return-policy-title"
        >
          Returns & Refunds Policy
        </h1>

        <p className="text-sm text-[#6B665F]">Siyaanish – Live Your Values</p>
        <p className="text-sm text-[#6B665F] mb-8">
          {/* Last updated: [Add Date] */}
          </p>

        <p className="text-[#6B665F] leading-relaxed mb-12">
          Siyaanish follows a no-return policy, in line with our small-batch and ethically
          sourced production model.
        </p>

        <div className="space-y-10 text-[#6B665F] leading-relaxed font-light">

          {/* 1 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">1. Returns</h2>
            <p className="mb-2">
              Returns are not accepted, except in the following cases:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Product received is damaged</li>
              <li>Manufacturing defect</li>
            </ul>
            <p className="mt-3">
              Claims must be reported within <strong>7 days</strong> of delivery.
            </p>
          </section>

          {/* 2 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              2. Replacement Policy
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Eligible damaged or defective products will be replaced</li>
              <li>Customers must provide clear images/videos as proof</li>
              <li>Product must be unused and in original condition</li>
            </ul>
            <p className="mt-3">
              Replacement is subject to availability. If replacement is not possible,
              store credit will be issued.
            </p>
          </section>

          {/* 3 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">3. Refunds</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>No monetary refunds</li>
              <li>Approved refunds will be issued as store credit only</li>
              <li>Store credit validity will be shared at the time of issuance</li>
            </ul>
          </section>

          {/* 4 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              4. Exclusions (Important)
            </h2>
            <p className="mb-2">
              Returns, replacements, or refunds will not be accepted for:
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Natural variations in colour, texture, weave, thickness, or finish</li>
              <li>Differences due to screen or lighting settings</li>
              <li>Minor inconsistencies inherent to natural or handmade fabrics</li>
              <li>Change of mind after purchase</li>
            </ul>
            <p className="mt-3">
              These variations are a natural characteristic of eco-friendly and
              plant-based materials.
            </p>
          </section>

          {/* 5 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              5. Care Instructions & Usage
            </h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Siyaanish is not responsible for damage caused by improper care</li>
              <li>Please follow provided care instructions carefully</li>
            </ul>
          </section>

          {/* 6 */}
          <section>
            <h2 className="font-serif text-2xl text-charcoal mb-4">
              6. Contact for Returns
            </h2>
            <p>
              All return or replacement requests must be sent to{' '}
              <a
                href="mailto:info@siyaanish.com"
                className="text-bronze hover:text-bronze-dark"
              >
                info@siyaanish.com
              </a>
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default ReturnPolicy;